import axios from "axios";
const RESOURCE_NAME = '/jobs';

export default {
    AddJobs(jobs) {
        return axios.post(`${RESOURCE_NAME}/`, jobs);
    },
};